import { BackOfficeCommentsTable } from "../../../../settlement/src/BackOfficeCommentsTable";
import { Button, DataHeader, DataSource, Layout, Panel, Tab, Tabset, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutDeposit extends Layout {
    buttonNextDeposit: Button;
    dataheaderDeposit: DataHeader;
    layoutBackOfficeCommentsTable: BackOfficeCommentsTable;
    panelTotals: Panel;
    sourceComments: DataSource;
    sourceDeposits: DataSource;
    tabComment: Tab;
    tabGeneral: Tab;
    tabsetDeposit: Tabset;
    textboxAmount: Textbox;
    textboxGlid: Textbox;
    textboxId: Textbox;
    textboxReceiptCount: Textbox;
    textboxReceiptDate: Textbox;
    textboxReceiptsTotal: Textbox;
    textboxUnappliedTotal: Textbox;
}
